<template>
  <div id="payment-error" class="error-page">
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card class="text-center">
          <div class="py-12">
            <!-- Error Icon -->
            <div class="error-icon mb-6">
              <i class="fas fa-exclamation-triangle text-6xl text-danger"></i>
            </div>
            
            <!-- Error Message -->
            <h1 class="text-3xl font-bold text-danger mb-4">
              Payment Error
            </h1>
            
            <p class="text-lg text-gray-600 mb-6">
              An error occurred during payment processing. Please try again or contact support.
            </p>
            
            <!-- Additional Message -->
            <div class="additional-message mb-6">
              <p class="text-gray-500">
                {{ message || 'If this problem persists, please contact our support team for assistance.' }}
              </p>
            </div>
            
            <!-- Action Buttons -->
            <div class="action-buttons">
              <vs-button 
                color="primary" 
                size="large"
                @click="goToCatalog"
                class="mr-4">
                <i class="fas fa-redo mr-2"></i>
                Try Again
              </vs-button>
              
              <vs-button 
                color="secondary" 
                size="large"
                @click="goToDashboard"
                class="mr-4">
                <i class="fas fa-home mr-2"></i>
                Go to Dashboard
              </vs-button>
              
              <vs-button 
                color="warning" 
                size="large"
                @click="contactSupport">
                <i class="fas fa-envelope mr-2"></i>
                Contact Support
              </vs-button>
            </div>
            
            <!-- Support Info -->
            <div class="support-info mt-8">
              <p class="text-sm text-gray-500">
                Our support team is available to help resolve any payment issues.
              </p>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaymentError',
  data() {
    return {
      message: ''
    };
  },
  mounted() {
    // Get message from query parameters if available
    const urlParams = new URLSearchParams(window.location.search);
    this.message = urlParams.get('message') || '';
  },
  methods: {
    goToCatalog() {
      this.$router.push('/licensing/catalog');
    },
    
    goToDashboard() {
      this.$router.push('/pages/home');
    },
    
    contactSupport() {
      // Open email client or redirect to support page
      window.location.href = 'mailto:support@tcvelik.com?subject=Payment Error Support';
    }
  }
};
</script>

<style scoped>
.error-page {
  padding: 2rem;
  max-width: 800px;
  margin: 0 auto;
  min-height: 100vh;
  display: flex;
  align-items: center;
}

.error-icon {
  animation: pulse 1s ease-in-out infinite;
}

@keyframes pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
}

.additional-message {
  max-width: 500px;
  margin: 0 auto;
}

.action-buttons {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 1rem;
}

.support-info {
  max-width: 400px;
  margin: 0 auto;
}

@media (max-width: 768px) {
  .error-page {
    padding: 1rem;
  }
  
  .action-buttons {
    flex-direction: column;
    align-items: center;
  }
  
  .action-buttons .vs-button {
    width: 100%;
    max-width: 300px;
  }
}
</style>
